import { render, staticRenderFns } from "./ProductPickerRow.vue?vue&type=template&id=279c7240&"
import script from "./ProductPickerRow.vue?vue&type=script&lang=ts&"
export * from "./ProductPickerRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports